import { render } from "./EachHeader.vue?vue&type=template&id=b701d79a&scoped=true"
import script from "./EachHeader.vue?vue&type=script&lang=js"
export * from "./EachHeader.vue?vue&type=script&lang=js"

import "./EachHeader.vue?vue&type=style&index=0&id=b701d79a&scoped=true&lang=stylus"

import exportComponent from "C:\\Users\\DGWA\\Documents\\tokyo-shoseki_R8_042024\\08k\\08k_sigb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b701d79a"]])

export default __exports__